import { render, staticRenderFns } from "./Format0201.vue?vue&type=template&id=af3550b2&scoped=true"
import script from "./Format0201.vue?vue&type=script&lang=js"
export * from "./Format0201.vue?vue&type=script&lang=js"
import style0 from "./Format0201.vue?vue&type=style&index=0&id=af3550b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3550b2",
  null
  
)

export default component.exports